import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { firstValueFrom } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { JsonReturn } from '../interface/generic-interface';


@Injectable({
  providedIn: 'root'
})
export class IdentityApiTargetService {

  constructor(private http: HttpClient) { }

  async authPainelTarget(){
    const resultado: any = await this.obterToken();
    return resultado;
  }

  async obterToken(): Promise<JsonReturn | null> {
    try {
      const response: any = await firstValueFrom(
        this.http.get(
          `${environment.restApiURL}authDistribuidora/painelTarget` ,
          {
            withCredentials: true
          }
        )
      );

      if (!response?.sucesso) {
        return null;
      }

      return response;
    } catch (error) {
      return null;
    }
  }
}


